import { render } from "./invoiceoverdue.vue?vue&type=template&id=33a1a4bc"
import script from "./invoiceoverdue.vue?vue&type=script&lang=js"
export * from "./invoiceoverdue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__